import React from 'react';
import PropTypes from 'prop-types';
import { Box, Link, Typography } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useStyles from './useStyles';

const LIST_PATH = '/myemailwork';

/**
 * "My email work" listesine dönüş. Liste durumu (sekme, kuyruk, sayfa, filtre) listenin kendi URL
 * sorgusundadır; geldiğimiz giriş listedense history.goBack() onu olduğu gibi geri getirir.
 *
 * - current: verilirse "My email work / <current>" breadcrumb'ı, verilmezse küçük "geri" bağlantısı
 * - preferBack: true ise (yığında önceki giriş varken) goBack kullanılır
 */
const BackToList = ({ current, preferBack }) => {
  const classes = useStyles();
  const history = useHistory();
  const { t } = useTranslation('mailorbit_workorder');

  const go = e => {
    e.preventDefault();
    if (preferBack && history.length > 1 && history.action === 'PUSH') history.goBack();
    else history.push(LIST_PATH);
  };

  const link = (
    <Link href={LIST_PATH} onClick={go} className={classes.crumbLink}>
      {current ? t('breadcrumb_my_email_work') : `← ${t('back_to_my_email_work')}`}
    </Link>
  );

  return (
    <Box className={classes.crumbs} component="nav" aria-label={t('breadcrumb_my_email_work')}>
      {link}
      {current && (
        <>
          <Typography component="span" variant="caption" aria-hidden="true">
            /
          </Typography>
          <Typography component="span" variant="caption" color="textPrimary">
            {current}
          </Typography>
        </>
      )}
    </Box>
  );
};

BackToList.propTypes = {
  current: PropTypes.string,
  preferBack: PropTypes.bool
};

BackToList.defaultProps = { current: '', preferBack: false };

export default BackToList;
